import { Controller } from "stimulus"

export default class extends Controller {
    id = 1;
    initialize() {
        if (document.getElementById("get-items")) {
            this.updateItems();
        } else {
            document.getElementById("items")
            var item = document.getElementById("items").firstChild.nextSibling;
            this.itemStyle = item.innerHTML;
            var items = document.getElementById("items");
            items.firstChild.nextSibling.lastChild.previousSibling.classList.add("hidden");
        }
    }

    addItem() {
        var items = document.getElementById("items");
        var div = document.createElement('div');
        div.classList = "flex flex-wrap w-full relative";
        div.id = `paytype${this.id}`;
        this.id += 1;
        div.innerHTML = this.itemStyle;
        items.appendChild(div);
        items.lastChild.lastChild.previousSibling.classList.remove("hidden");
    }

    delete(event) {
        var id = event.target.parentElement.id;
        var items = document.getElementById("items");
        var element = document.getElementById(id);
        element.parentElement.removeChild(element);
        this.id -= 1;
    }

    updateItems() {
        var item = document.getElementById("item");
        this.itemStyle = item.innerHTML;
        var items = document.getElementById("items");
        this.id = document.getElementById("items").childElementCount;
        items.firstChild.nextSibling.lastChild.previousSibling.classList.add("hidden");
    }
}